import { forbiddenSearchChars } from './regex'

/** Preserve measurement separators before the general search character filter.
 * Also retain a separator while typing the following axis/decimal digit. */
export const formatSearchInput = (query: string) => query
  .substring(0, 255)
  .replace(/(\d),(?=\d|$)/g, '$1.')
  .replace(/(\d)\s*[×*]\s*(?=\d|$)/g, '$1x')
  .replace(forbiddenSearchChars, '')

export const saveSearchQuery = (query: string) => formatSearchInput(query)
  .replace(/\s+/g, ' ')
  .trim()
